import { render, staticRenderFns } from "./language.vue?vue&type=template&id=bb85daaa&scoped=true&"
import script from "./language.vue?vue&type=script&lang=js&"
export * from "./language.vue?vue&type=script&lang=js&"
import style0 from "./language.vue?vue&type=style&index=0&id=bb85daaa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb85daaa",
  null
  
)

export default component.exports